import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '周边分类', path: '/category' },
  { label: '精选文章', path: '/article' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex items-center justify-between h-16 md:h-18 px-4 md:px-6 max-w-[1400px]">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-bear-smile-line text-background-50 text-lg md:text-xl"></i>
          </div>
          <span
            className="text-xl md:text-2xl font-heading font-semibold"
            style={{
              color: isScrolled || !isHome ? 'oklch(var(--primary-600))' : 'oklch(var(--background-50))',
            }}
          >
            黄油小熊
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : isScrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                      : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/15'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="打开菜单"
        >
          <i
            className={`text-xl ${
              isScrolled || !isHome ? 'text-foreground-800' : 'text-background-50'
            } ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
          ></i>
        </button>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </div>
      )}
    </header>
  );
}